import {formatarValor} from "@/helpers/index.js";
import formatarValoresBi from "@/helpers/formatarValoresBi.js";

const colors = [
  '#c0c0c0',
  '#ee2b2b',
  '#0a3950',
  '#25c045',
  '#171717',
  '#e8c900',
  '#ad16de',
  '#ad16de',
  '#25c045',
  '#9f9f9f',
];

function formatarValores(valor) {
  if (valor <= 1000) return formatarValor(valor);
  return formatarValoresBi(valor);
}

export const opcoes = {
  color: colors,
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        formatter: label => {
          if (label.axisDimension === 'y') {
            return formatarValor(parseInt(label.value));
          }

          return label.value;
        }
      }
    },
    valueFormatter: valor => formatarValor(valor)
  },
  grid: {
    left: '40px',
    right: '55px',
    bottom: 25
  },
  legend: {
    padding: 20
  },
  xAxis: [
    {
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      data: new Array(12).fill("00/00/0000"),
    }
  ],
  yAxis: [
    {
      type: 'value',
      name: '',
      position: 'left',
      axisLine: {
        show: true,
      },
      axisLabel: {
        formatter: formatarValores
      },
      axisPointer: {
        formatter: x => x + 'oi'
      },
      max: item => item.max * 1.15,
    },
    {
      type: 'value',
      name: '',
      position: 'right',
      axisLine: {
        show: true
      },
      axisLabel: {
        formatter: value => formatarValores(value) + ' dias'
      },
    }
  ],
  series: [
    {
      type: 'line',
      name: 'Estoque',
      chave: 'estoque',
      yAxisIndex: 0,
      showSymbol: false,
      stack: 'Saldo de Estoque',
      data: [],
      lineStyle: {
        width: 1,
      },
      areaStyle: {
        color: '#e1e1e1',
        opacity: .2
      },
      z: 0
    },
    {
      name: 'Saídas',
      chave: 'saida',
      type: 'bar',
      yAxisIndex: 0,
      data: []
    },
    {
      name: 'Entradas',
      chave: 'entrada',
      type: 'bar',
      yAxisIndex: 0,
      data: []
    },
    {
      name: 'Entrada Sugestão Systock',
      chave: 'sugestao',
      type: 'bar',
      yAxisIndex: 0,
      data: []
    },
    {
      name: 'Eseg',
      chave: 'estoque_seguranca',
      type: 'line',
      yAxisIndex: 0,
      showSymbol: false,
      data: []
    },
    {
      name: 'PP',
      chave: 'ponto_pedido',
      type: 'line',
      yAxisIndex: 0,
      showSymbol: false,
      data: []
    },
    {
      name: 'EMáx',
      chave: 'estoque_maximo',
      type: 'line',
      yAxisIndex: 0,
      showSymbol: false,
      data: []
    },
    {
      name: 'Cobertura Estoque',
      chave: 'cobertura_estoque',
      type: 'line',
      yAxisIndex: 1,
      showSymbol: false,
      lineStyle: {
        normal: {
          width: 1,
          type: 'dashed'
        }
      },
      data: []
    },
    {
      name: 'Disparo do Pedido',
      chave: 'disparo_pedido',
      type: 'line',
      yAxisIndex: 1,
      showSymbol: false,
      lineStyle: {
        normal: {
          width: 1,
          type: 'dashed'
        }
      },
      data: []
    },
    {
      name: 'TR',
      chave: 'tempo_ressuprimento',
      type: 'line',
      yAxisIndex: 1,
      showSymbol: false,
      lineStyle: {
        normal: {
          width: 2,
          type: 'dashed'
        }
      },
      data: []
    },
  ]
};
